import { render, staticRenderFns } from "./VerifyLogin.vue?vue&type=template&id=6704009f"
import script from "./VerifyLogin.vue?vue&type=script&lang=js"
export * from "./VerifyLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports